module.exports = __webpack_public_path__ + "static/media/51.7d4920fb.jpg";